<template>
  <div class="pokedex-home">
    <div class="header">
      <h1>宝可梦图鉴</h1>
    </div>

    <div class="scroll-container">
      <div class="grid">
        <div
          class="card"
          v-for="pokemon in pokemons"
          :key="pokemon.id"
          @click="goToDetail(pokemon.id)"
        >
          <img class="icon" :src="pokemon.icon" :alt="pokemon.name" />
          <div class="info">
            <p class="id">No. {{ pokemon.id }}</p>
            <p class="name">{{ pokemon.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PokedexHome",
  data() {
    return {
      pokemons: [],
    };
  },
  mounted() {
    this.$axios.get("/pokedex/list").then(res => {
      this.pokemons = res.data.sort((a, b) => a.id - b.id);
    });
  },
  methods: {
    goToDetail(id) {
      this.$router.push(`/pokedex/detail/${id}`);
    },
  },
};
</script>

<style scoped>
.pokedex-home {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f0f0f0;
}

/* 顶部标题栏 */
.header {
  background-color: #4caf50;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}

/* 可滚动区域 */
.scroll-container {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* 卡片网格 */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 15px;
}

/* 宝可梦卡片 */
.card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  padding: 12px;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.card:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.icon {
  width: 80px;
  height: 80px;
  object-fit: contain;
  margin-bottom: 8px;
}

.info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.id {
  font-size: 12px;
  color: #666;
}

.name {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
</style>